import React from 'react'
import { Color23, Colors23 } from '@grammarly/badger-ui'

interface PlayIconProps {
  fill?: string
  color?: Color23
}

export const PlayIcon: React.FC<PlayIconProps> = ({ fill = 'none', color }) => {
  const foregroundColor = color ? Colors23[color] : '#565B6C'

  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill={fill} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <g clipPath="url(#clip0_2_193)">
        <circle cx="16" cy="16" r="15" stroke={foregroundColor} strokeWidth="2" />
        <path
          d="M21.7003 15.1601C22.31 15.5541 22.31 16.4459 21.7003 16.8399L14.234 21.6648C13.5686 22.0948 12.6913 21.6172 12.6913 20.825L12.6913 11.175C12.6913 10.3828 13.5686 9.90516 14.234 10.3352L21.7003 15.1601Z"
          fill={foregroundColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_2_193">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
